
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M8 3a5 5 0 110 10A5 5 0 018 3zm.375 2c-.892 0-1.625.698-1.625 1.571L6.749 8H6.5l-.09.008A.5.5 0 006.5 9h.249l.001.786-.009.055a.236.236 0 01-.173.151L6.5 10l-.105.009c-.527.093-.527.889 0 .982L6.5 11h3l.09-.008A.5.5 0 0010 10.5l-.008-.09A.5.5 0 009.5 10H7.729l.014-.09a1.2 1.2 0 00.007-.124L7.749 9H8.5l.09-.008A.5.5 0 008.5 8h-.751l.001-1.429.008-.09C7.806 6.21 8.06 6 8.375 6c.35 0 .625.261.625.571l.008.09a.5.5 0 00.992-.09C10 5.698 9.267 5 8.375 5z"}})])
          )
        }
      }
    